import EsetechMetaAds from "pages/Marketing/components/MetaAds/EsetechMetaAds";
import KaapoMetaAds from "pages/Marketing/components/MetaAds/KaapoMetaAds";
import { FullWidthTabs } from "components";
import React, { useState } from "react";

const Campaign = () => {
  const tabList = [
    {
      label: "Esetech",
      Comp: EsetechMetaAds,
    },
    {
      label: "Kaapo",
      Comp: KaapoMetaAds,
    },
  ];

  const [currentTab, setCurrentTab] = useState(tabList[0]);

  return (
    <FullWidthTabs
      {...{ currentTab, setCurrentTab, tabList }}
      Comp={<currentTab.Comp {...currentTab} />}
    />
  );
};

export default Campaign;
